export const getOCClaimItemsQueryKey = (fbOcKey: number | undefined) => ['claims-over-charge-items', fbOcKey] as const;

export const getOCClaimCommentsQueryKey = (fbOcKey: number | undefined) =>
  ['claims-over-charge-comments', fbOcKey] as const;

export const getOCClaimSettlementsQueryKey = (fbOcKey: number | undefined) =>
  ['claims-over-charge-settlements', fbOcKey] as const;

export const invalidateOCClaimTabQueries = (
  queryClient: { invalidateQueries: (options: { queryKey: readonly unknown[] }) => void },
  fbOcKey: number | undefined,
) => {
  if (!fbOcKey) {
    return;
  }
  queryClient.invalidateQueries({ queryKey: getOCClaimItemsQueryKey(fbOcKey) });
  queryClient.invalidateQueries({ queryKey: getOCClaimCommentsQueryKey(fbOcKey) });
  queryClient.invalidateQueries({ queryKey: getOCClaimSettlementsQueryKey(fbOcKey) });
};
